import { useRouter } from "next/router";
import Link from "next/link";
import { HeaderButton } from "./button/button";
import Button from "@shared/components/button/Button";
import {
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button/types";
import ProfileMenu from "./profile-menu";
import { FC } from "react";
import { useLayoutContext } from "@context/layout";

const ProfileButton: FC = () => {
  const router = useRouter();
  const { userData, isUserDataLoading } = useLayoutContext();

  return (
    <div className="hidden md:block">
      {isUserDataLoading ? (
        <Button
          size={BUTTON_SIZE.SMALL}
          variant={BUTTON_VARIANT.FILL}
          color={BUTTON_COLOR.NEUTRAL}
          className="animate-pulse w-24 !bg-fds-disable hidden md:block"
        />
      ) : userData?.is_login ? (
        <ProfileMenu />
      ) : (
        <Link
          href={
            router.pathname === "/"
              ? "/register"
              : `/register?next=${encodeURIComponent(router.asPath)}`
          }
          prefetch={false}
          as="/register"
          aria-label="register/login"
          className="ml-1 hidden md:block"
        >
          <HeaderButton
            className="h-8 px-3.5"
            size="medium"
            label="   ورود / عضویت"
          />
        </Link>
      )}
    </div>
  );
};

export default ProfileButton;
